import { deriveGrowth } from './channelGrowth'

// Shared shapes for the channel quarterly breakdown table and its summary row.
export interface Channel { id: string; name: string; slug: string; position?: number }
export interface Quarter { label: string; start_date: string; end_date: string }

export interface QuarterlyMatrix {
  channels: Channel[]
  past_quarters: Quarter[]
  // Quarters already covered by this version's actual sales. Empty for a
  // plain version.
  actual_quarters: Quarter[]
  plan_quarters: Quarter[]
  past: Record<string, Record<string, string>>
  plan: Record<string, Record<string, number>>
  ytd: Record<string, Record<string, string>>
  actual: Record<string, Record<string, string>>
  // Each finished quarter's target from the version it ran under; null
  // when no version planned it.
  actual_targets?: Record<string, Record<string, number | null>>
  channel_targets: Record<string, number>
}

// "Q1" plus the quarter's year, for the Actual / Plan headers ("Actual Q1 2026").
export const withYear = (q: Quarter) => `${q.label} ${q.start_date.slice(0, 4)}`

// Year of the first past quarter, for the "Total 2025" header.
export const pastYear = (quarters: Quarter[]) => quarters[0]?.start_date.slice(0, 4) ?? ''

export const sumOver = (quarters: Quarter[], cells: Record<string, string | number> | undefined) =>
  quarters.reduce((s, q) => s + Number(cells?.[q.start_date] ?? 0), 0)

// Growth for the year as the editor's Growth % cell shows it: the full year
// over the past year's total. "—" when there is no past to compare against.
export const growthLabel = (past: number, fullYear: number) => {
  const g = deriveGrowth({ past, plan: fullYear })
  return g === '' ? '—' : `${g}%`
}
